// Define the type for the sample mappings
type SampleMappings = {
  [key: string]: string[];
};

export const samplesMappings: SampleMappings = {
  kleurstaalzenenzachtlichtgroenbeigevilt: [
    "kleurstaalzenenzachtgrijsgroenbeigevilt",
    "kleurstaalvolledigviltbeigevilt",
    "kleurstaalzenenzachtivoorbeigevilt",
  ],
  kleurstaalzenenzachtlichtgroenzwartvilt: [
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalzenenzachtgrijsgroenzwartvilt",
    "kleurstaalvolledigviltzwartvilt",
  ],
  kleurstaalvolledigviltbeigevilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalvgroefbeige",
  ],
  kleurstaalvolledigviltzwartvilt: [
    "kleurstaalvgroefzwart",
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalmachtigmetalliczwartzwartvilt",
  ],
  kleurstaalvgroefbeige: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalvolledigviltbeigevilt",
    "kleurstaalzenenzachtbeigebeigevilt",
  ],
  kleurstaalvgroefzwart: [
    "kleurstaalzenenzachttaupebeigevilt",
    "kleurstaalmachtigmetalliczwartzwartvilt",
    "kleurstaalvolledigviltzwartvilt",
  ],
  kleurstaalzenenzachttaupebeigevilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalvolledigviltbeigevilt",
    "kleurstaalzenenzachtbeigebeigevilt",
  ],
  kleurstaalzenenzachttaupezwartvilt: [
    "kleurstaalmachtigmetalliczwartzwartvilt",
    "kleurstaalmachtigmetallictaupezwartvilt",
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
  ],
  kleurstaalzenenzachtzalmbeigevilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalvolledigviltbeigevilt",
    "kleurstaalzenenzachtbeigebeigevilt",
  ],
  kleurstaalzenenzachtzalmmetzwartvilt: [
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalzenenzachtzalmbeigevilt",
    "kleurstaalzenenzachtterracottazwartvilt",
  ],
  kleurstaalzenenzachtivoorbeigevilt: [
    "kleurstaalvolledigviltbeigevilt",
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalzenenzachtbeigebeigevilt",
  ],
  kleurstaalzenenzachtivoormetzwartvilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalmachtigmetallicparelmoermetzwartvilt",
    "kleurstaaleindprofielgitzwart",
  ],
  kleurstaalzenenzachtbeigebeigevilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalzenenzachttaupebeigevilt",
  ],
  kleurstaalzenenzachtbeigemetzwartvilt: [
    "kleurstaalvolledigviltbeigevilt",
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalzenenzachtgrijsgroenzwartvilt",
  ],
  kleurstaalzenenzachtgrijsgroenbeigevilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalzenenzachttaupebeigevilt",
    "kleurstaalzenenzachtlichtgroenbeigevilt",
  ],
  kleurstaalzenenzachtgrijsgroenzwartvilt: [
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalmachtigmetallicdonkergroenzwartvilt",
    "kleurstaalzenenzachtbeigezwartvilt",
  ],
  kleurstaalzenenzachtterracottametbeigevilt: [
    "kleurstaalzenenzachtzalmbeigevilt",
    "kleurstaalzenenzachtterracottazwartvilt",
  ],
  kleurstaalzenenzachtterracottazwartvilt: [
    "kleurstaalzenenzachtzalm",
    "kleurstaalgeweldigeglinsteringkoperzwartvilt",
    "kleurstaalzenenzachtterracottametbeigevilt",
  ],
  kleurstaalgeweldigeglinsteringbronszwartvilt: [
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
    "kleurstaalgeweldigeglinsteringgoudzwartvilt",
    "kleurstaaleindprofielbrons",
  ],
  kleurstaalgeweldigeglinsteringbronsmetbeigevilt: [
    "kleurstaalgeweldigeglinsteringmokkametbeigevilt",
    "kleurstaalgeweldigeglinsteringgoudmetbeigevilt",
    "kleurstaaleindprofielbeige",
  ],
  kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt: [
    "kleurstaalgeweldigeglinsteringgoudzwartvilt",
    "kleurstaalgeweldigeglinsteringmokkazwartvilt",
    "kleurstaaleindprofielgitzwart",
  ],
  kleurstaalgeweldigeglinsteringgrijsbruinmetbeigevilt: [
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalmachtigmetallictaupezwartvilt",
  ],
  kleurstaalgeweldigeglinsteringgoudzwartvilt: [
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
    "kleurstaalmachtigmetallicchampagnezwartvilt",
    "kleurstaalgeweldigeglinsteringmokkazwartvilt",
  ],
  kleurstaalgeweldigeglinsteringgoudmetbeigevilt: [
    "kleurstaalgeweldigeglinsteringgoudzwartvilt",
    "kleurstaaleindprofielbeige",
    "kleurstaalgeweldigeglinsteringmokkametbeigevilt",
  ],
  kleurstaalgeweldigeglinsteringkoperzwartvilt: [
    "kleurstaalgeweldigeglinsteringgoudmetbeigevilt",
    "kleurstaalgeweldigeglinsteringgoudzwartvilt",
    "kleurstaalmachtigmetallicchampagnezwartvilt",
  ],
  kleurstaalgeweldigeglinsteringkopermetbeigevilt: [
    "kleurstaalgeweldigeglinsteringkoperzwartvilt",
    "kleurstaalzenenzachtterracottametbeigevilt",
    "kleurstaalzenenzachtzalmbeigevilt",
  ],
  kleurstaalgeweldigeglinsteringmokkazwartvilt: [
    "kleurstaalgeweldigeglinsteringgoudzwartvilt",
    "kleurstaalgeweldigeglinsteringkoperzwartvilt",
    "kleurstaaleindprofielgitzwart",
  ],
  kleurstaalgeweldigeglinsteringmokkametbeigevilt: [
    "kleurstaaleindprofielbeige",
    "kleurstaalmachtigmetallicchampagnebeigevilt",
    "kleurstaalgeweldigeglinsteringgoudmetbeigevilt",
  ],
  kleurstaalmachtigmetallicdonkergroenzwartvilt: [
    "kleurstaalmachtigmetallicdonkergroenzwartvilt",
    "kleurstaaleindprofielgitzwart",
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
  ],
  kleurstaalmachtigmetallicdonkergroenmetbeigevilt: [
    "kleurstaalzenenzachtlichtgroenbeigevilt",
    "kleurstaalzenenzachtgrijsgroenbeigevilt",
    "kleurstaaleindprofielbeige",
  ],
  kleurstaalmachtigmetalliczwartzwartvilt: [
    "kleurstaalmachtigmetallicdonkergroenzwartvilt",
    "kleurstaalgeweldigeglinsteringgrijsbruinmetbeigevilt",
    "kleurstaalzenenzachttaupebeigevilt",
  ],
  kleurstaalmachtigmetalliczwartmetbeigevilt: [
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalmachtigmetalliczwartzwartvilt",
    "kleurstaalgeweldigeglinsteringmokkazwartvilt",
  ],
  kleurstaalmachtigmetallicparelmoermetzwartvilt: [
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalmachtigmetallicchampagnezwartvilt",
    "kleurstaalzenenzachtbeigemetzwartvilt",
  ],
  kleurstaalmachtigmetallicparelmoerbeigevilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalvgroefbeige",
  ],
  kleurstaalmachtigmetallicchampagnezwartvilt: [
    "kleurstaalgeweldigeglinsteringgoudzwartvilt",
    "kleurstaalgeweldigeglinsteringmokkazwartvilt",
    "kleurstaalgeweldigeglinsteringkoperzwartvilt",
  ],
  kleurstaalmachtigmetallicchampagnebeigevilt: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalvgroefbeige",
  ],
  kleurstaalmachtigmetallictaupezwartvilt: [
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalmachtigmetallictaupemetbeigevilt",
  ],
  kleurstaalmachtigmetallictaupemetbeigevilt: [
    "kleurstaalzenenzachttaupebeigevilt",
    "kleurstaalmachtigmetallicchampagnebeigevilt",
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
  ],
  kleurstaaleindprofielzuiverwit: [
    "kleurstaaleindprofielparelwit",
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalzenenzachtbeigebeigevilt",
  ],
  kleurstaaleindprofielgitzwart: [
    "kleurstaalmachtigmetalliczwartzwartvilt",
    "kleurstaaleindprofielzwartgrijs",
    "kleurstaalvolledigviltzwartvilt",
  ],
  kleurstaaleindprofielzwartgrijs: [
    "kleurstaaleindprofielleem",
    "kleurstaalgeweldigeglinsteringbronszwartvilt",
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
  ],
  kleurstaaleindprofielbeige: [
    "kleurstaalvolledigviltbeigevilt",
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalzenenzachtbeigebeigevilt",
  ],
  kleurstaaleindprofielgoud: [
    "kleurstaalgeweldigeglinsteringkopermetbeigevilt",
    "kleurstaalgeweldigeglinsteringgoudzwartvilt",
    "kleurstaalmachtigmetallicchampagnezwartvilt",
  ],
  kleurstaaleindprofielmahonie: [
    "kleurstaalzenenzachttaupezwartvilt",
    "kleurstaalzenenzachtzalmbeigevilt",
    "kleurstaalzenenzachtterracottazwartvilt",
  ],
  kleurstaaleindprofielleem: [
    "kleurstaaleindprofielbrons",
    "kleurstaalmachtigmetallictaupezwartvilt",
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
  ],
  kleurstaaleindprofielolijf: [
    "kleurstaalzenenzachtgrijsgroenzwartvilt",
    "kleurstaaleindprofielkiezelgrijs",
    "kleurstaaleindprofielgitzwart",
  ],
  kleurstaaleindprofielkiezelgrijs: [
    "kleurstaalzenenzachtgrijsgroenzwartvilt",
    "kleurstaalzenenzachtlichtgroenbeigevilt",
    "kleurstaaleindprofielolijf",
  ],
  kleurstaaleindprofielvenstergrijs: [
    "kleurstaalvolledigviltzwartvilt",
    "kleurstaaleindprofielgitzwart",
    "kleurstaalmachtigmetalliczwartzwartvilt",
  ],
  kleurstaaleindprofieldonkerbrons: [
    "kleurstaaleindprofielleem",
    "kleurstaalgeweldigeglinsteringbronszwartvilt",
    "kleurstaalgeweldigeglinsteringgrijsbruinzwartvilt",
  ],
  kleurstaaleindprofielgrijsbeige: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalmachtigmetallicparelmoerbeigevilt",
    "kleurstaalvgroefbeige",
  ],
  kleurstaaleindprofieltaupe: [
    "kleurstaalmachtigmetalliczwartzwartvilt",
    "kleurstaalmachtigmetallictaupezwartvilt",
    "kleurstaalzenenzachttaupebeigevilt",
  ],
  kleurstaaleindprofielparelwit: [
    "kleurstaalzenenzachtivoorbeigevilt",
    "kleurstaalzenenzachtbeigebeigevilt",
    "kleurstaaleindprofielzuiverwit",
  ],
  kleurstaaleindprofielgrijsblauw: [
    "kleurstaalvolledigviltzwartvilt",
    "kleurstaaleindprofielgitzwart",
    "kleurstaalmachtigmetalliczwartzwartvilt",
  ],

  // Glasscleaners
  zoschoonglasstart: [
    "zoschoonglasnavul",
    "zoschoonglasdoek",
    "zoschoonglasdoekxl",
  ],
  zoschoonglasnavul: [
    "zoschoonglasstart",
    "zoschoonglasdoek",
    "zoschoonglasdoekxl",
  ],
  zoschoonglasdoek: [
    "zoschoonglasstart",
    "zoschoonglasnavul",
    "zoschoonglasdoekxl",
  ],

  zoschoonglasdoekxl: [
    "zoschoonglasstart",
    "zoschoonglasnavul",
    "zoschoonglasdoek",
  ],

  zoschoonallesstart: [
    "zoschoonallesnavul",
    "zoschoonallesdoek",
    "zoschoonglasstart",
  ],

  zoschoonallesnavul: [
    "zoschoonallesdoek",
    "zoschoonallesstart",
    "zoschoonglasstart",
  ],

  zoschoonallesdoek: [
    "zoschoonallesstart",
    "zoschoonallesnavul",
    "zoschoonglasdoek",
  ],
};

const defaultRecommendedSamples = [
  "kleurstaalzenenzachtgrijsgroenbeigevilt",
  "kleurstaalvolledigviltbeigevilt",
  "kleurstaalzenenzachtivoorbeigevilt",
];

export const useRecommendedSamples = () => {
  const getRecommendedSamples = (sampleCode: string) => {
    return samplesMappings[sampleCode] || defaultRecommendedSamples;
  };

  return { getRecommendedSamples };
};
